import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Layout,
  Flex,
  Card,
  Row,
  Col,
  Select,
  Radio,
  Table,
  Badge,
  Divider,
  Button,
  Spin,
  Avatar,
  Tag,
  Checkbox,
  Input,
  Tooltip as AntTooltip,
  Segmented,
  Tabs,
  DatePicker,
} from "antd";

import {
  FilterOutlined,
  InfoCircleOutlined,
  MoreOutlined,
  RiseOutlined,
  FallOutlined,
  EllipsisOutlined,
  UserOutlined,
  DownOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import "../dashboard/NewDashboard.css";
import axios from "axios";
import dayjs from "dayjs";
import { BE_HOST } from "../../config/config";
import { setPharmacyData } from "../../redux/reducer/dataReducer.js";
import { formatMonthLabel, formatQuarterLabel } from "../../utils/helper.js";
const { Content } = Layout;
const { Option } = Select;

const getOrdinalSuffix = (num) => {
  const suffixes = ["th", "st", "nd", "rd"];
  const v = num % 100;
  return suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
};

const { TabPane } = Tabs;

const ChatDashboard = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const accountIdParams = searchParams.get("accountId");
  const accountName = searchParams.get("name");
  const [AllUser, setAllUser] = useState([]);
  const [selectedPharmacies, setSelectedPharmacies] = useState(
    accountIdParams ? [Number(accountIdParams)] : [],
  );
  const [selectedfilter, setselectedfilter] = useState("month");

  const [rebatePerformance, setRebatePerformace] = useState([]);
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activePeriod, setActivePeriod] = useState("current");
  const [year, setYear] = useState(new Date().getFullYear());
  const [GCRPer, setAPIdata] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState(AllUser);
  const [allUserFetched, setAllUserFetched] = useState(false); // new flag
  const [calculatedData, setCalculatedData] = useState([]);
  const [gcrPercentage, setGcrPercentage] = useState([]);
  const [selectedGcr, setSelectedGcr] = useState(null);
  const [animateValues, setAnimateValues] = useState(false);

  const dispatch = useDispatch();
  const { loading } = useSelector(
    (state) => state.accounts || { assignedAccounts: [], loading: false },
  );
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const getCurrentMonthOption = () => {
    const now = dayjs();

    const label = now.format("MMM YYYY");
    const monthValue = now.format("M");
    const year = now.format("YYYY");

    return {
      key: label,
      label: label,
      value: monthValue,
      year: year,
    };
  };

  const [selectedOption, setSelectedOption] = useState(getCurrentMonthOption());

  const updatePharmacies = (value) => {
    setSelectedPharmacies(value);
    dispatch(setPharmacyData(value));
  };

  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Add this function to calculate dates for both month and quarter
  const getDateRange = (filter, selectedValue, selectedYear) => {
    if (filter === "quarter") {
      const quarters = {
        1: { start: "01-01", end: "03-31" },
        2: { start: "04-01", end: "06-30" },
        3: { start: "07-01", end: "09-30" },
        4: { start: "10-01", end: "12-31" },
      };
      return {
        fromDate: `${selectedYear}-${quarters[selectedValue].start}`,
        thruDate: `${selectedYear}-${quarters[selectedValue].end}`,
      };
    } else {
      // For monthly view
      const today = new Date();
      const month = selectedValue.padStart(2, "0");
      const startDate = `${selectedYear}-${month}-01`;
      const thruDate =
        today.getFullYear() === parseInt(selectedYear) &&
        today.getMonth() + 1 === parseInt(selectedValue)
          ? today.toISOString().split("T")[0] // If current month, use today's date
          : new Date(selectedYear, selectedValue, 0)
              .toISOString()
              .split("T")[0]; // Last day of selected month

      return { fromDate: startDate, thruDate };
    }
  };

  // Modify the fetchAllData function to handle loading state
  const apiVersion =
    Number(selectedOption?.year) > 2025 ||
    (Number(selectedOption?.year) === 2025 && Number(selectedOption.value) >= 9)
      ? ""
      : "";
  const apiVersionUsers =
    Number(selectedOption?.year) > 2025 ||
    (Number(selectedOption?.year) === 2025 && Number(selectedOption.value) >= 9)
      ? ""
      : "";
  const fetchAllData = async () => {
    // if (!token) return;

    setIsLoading(true); // Set loading to true when fetching starts
    try {
      setIsLoading(true);

      // Get dates based on selected quarter
      const { fromDate, thruDate } = getDateRange(
        selectedfilter,
        selectedOption.value,
        selectedOption?.year,
      );
      if (
        selectedPharmacies?.length > 0
      ) {
        const gcrRes = await axios.get(
          `${BE_HOST}/api${apiVersion}/powerbi/getGCRPercentageForChats?period=${selectedfilter}&value=${selectedOption?.value}&year=${selectedOption?.year}&accounts=${selectedPharmacies}`,
        );
        // console.log(gcrRes,"gcrResgcrResgcrRes")
        setAPIdata(gcrRes?.data);
      }
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
    } finally {
      setIsLoading(false);
      setAllUserFetched(true); // ✅ important
    }
  };

  useEffect(() => {
    if (!allUserFetched) return;
    if (AllUser?.length > 0 && selectedPharmacies?.length === 0) {
      // setSelectedPharmacies([AllUser[0].acct_id]);
      const specialUser = AllUser?.find((user) => user?.acct_id === 96167);
      if (specialUser) {
        setSelectedPharmacies([specialUser?.acct_id]);
        dispatch(setPharmacyData([specialUser?.acct_id]));
      } else {
        setSelectedPharmacies([AllUser[0]?.acct_id]);
        dispatch(setPharmacyData([AllUser[0]?.acct_id]));
      }
    } else if (AllUser?.length == 0 && selectedPharmacies.length === 0) {
      setModalVisible(true);
    }
  }, [AllUser, selectedPharmacies, allUserFetched]);

  const GenericRx = Number(
    isNaN(GCRPer?.raw_data?.Generic_Rx) ? 0 : GCRPer?.raw_data?.Generic_Rx || 0,
  ).toFixed(2);

  const OnStopGeneric = Number(
    isNaN(GCRPer?.raw_data?.OnStop_Generic)
      ? 0
      : GCRPer?.raw_data?.OnStop_Generic || 0,
  ).toFixed(2);

  const TotalRx = Number(
    isNaN(GCRPer?.raw_data?.Total_Rx) ? 0 : GCRPer?.raw_data?.Total_Rx || 0,
  ).toFixed(2);

  const Brand_Rx = Number(
    isNaN(GCRPer?.raw_data?.Brand_Rx) ? 0 : GCRPer?.raw_data?.Brand_Rx || 0,
  ).toFixed(2);

  const estimatedCurrentRebate = Number(
    isNaN(GCRPer?.raw_data?.estimatedCurrentRebate)
      ? 0
      : GCRPer?.raw_data?.estimatedCurrentRebate || 0,
  ).toFixed(2);

  // Last Period

  const last_GenericRx = Number(
    isNaN(GCRPer?.lastMetrics?.Generic_Rx)
      ? 0
      : GCRPer?.lastMetrics?.Generic_Rx || 0,
  ).toFixed(2);

  const last_OnStopGeneric = Number(
    isNaN(GCRPer?.lastMetrics?.OnStop_Generic)
      ? 0
      : GCRPer?.lastMetrics?.OnStop_Generic || 0,
  ).toFixed(2);

  const last_TotalRx = Number(
    isNaN(GCRPer?.lastMetrics?.Total_Rx)
      ? 0
      : GCRPer?.lastMetrics?.Total_Rx || 0,
  ).toFixed(2);

  const last_Brand_Rx = Number(
    isNaN(GCRPer?.lastMetrics?.Brand_Rx)
      ? 0
      : GCRPer?.lastMetrics?.Brand_Rx || 0,
  ).toFixed(2);

  const last_estimatedCurrentRebate = Number(
    isNaN(GCRPer?.lastMetrics?.estimatedCurrentRebate)
      ? 0
      : GCRPer?.lastMetrics?.estimatedCurrentRebate || 0,
  ).toFixed(2);

  useEffect(() => {
    fetchAllData();
    // getTargetData();
    setAnimateValues(true);
    const timer = setTimeout(() => setAnimateValues(false), 500);
    return () => clearTimeout(timer);
  }, [selectedfilter, selectedOption, selectedPharmacies]);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Step 1: Transform and Sort Data
  const processedRebateData = [...rebatePerformance]
    .map((item) => ({
      ...item,
      month: `${monthNames[item.month_num - 1]} ${item.year}`,
    }))
    .sort((a, b) => {
      if (a.year !== b.year) return b.year - a.year;
      return b.month_num - a.month_num;
    });

  useEffect(() => {
    const filtered = AllUser.filter((user) => {
      const { displayName, displayId } = getDisplayPharmacy(user);
      return (
        displayName.toLowerCase().includes(searchText.toLowerCase()) ||
        String(displayId || "").includes(searchText)
      );
    });
    setFilteredUsers(filtered);
  }, [searchText, AllUser]);

  const isCurrentMonth = (monthData) => {
    const now = new Date();
    const currentMonth = now.getMonth() + 1; // 1-12
    const currentYear = now.getFullYear();

    if (
      parseInt(monthData.value) === currentMonth &&
      monthData.key.includes(currentYear)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const disabledMonth = (current) => {
    const MIN_MONTH = dayjs("2025-01", "YYYY-MM");
    const MAX_MONTH = dayjs(); // always current month
    if (!current) return false;

    return (
      current.isBefore(MIN_MONTH, "month") ||
      current.isAfter(MAX_MONTH, "month")
    );
  };
  const onChangeMonth = (date) => {
    if (!date) return;

    const label = date.format("MMM YYYY"); // Jan 2026
    const monthValue = date.format("M"); // 1
    const year = date.format("YYYY"); // 2026

    const option = {
      key: label,
      label: label,
      value: monthValue,
      year: year,
    };

    setSelectedOption(option);
  };

  const getDisplayPharmacy = (account) => {
    const isGoodUser = userAuth?.user_roles_id === 5;

    if (isGoodUser && account?.acct_id === 96167) {
      return {
        ...account,
        displayName: "ABC Pharmacy",
        displayId: "123456",
      };
    }

    return {
      ...account,
      displayId: account.acct_id,
      displayName: account.name || account.label,
    };
  };
  const accountMap = React.useMemo(() => {
    const map = {};
    AllUser?.forEach((acc) => {
      map[acc.acct_id] = acc.name;
    });
    return map;
  }, [AllUser]);

  const AccountUI = ({ pharmacy }) => {
    return (
      <div
        className="w-full md:w-[400px] min-h-[40px] flex flex-wrap items-center gap-2 px-2 py-1"
        style={{
          border: "1px solid #fff",
          borderRadius: "6px",
          minHeight: "70px",
          // background: "#fff",
        }}
      >
        <div className="flex gap-2 items-center">
          <div>
            <Tag
              closable={false}
              style={{
                border: "none",
                backgroundColor: "transparent",
                borderRadius: "3px",
                padding: "4px 12px",
                fontSize: "20px",
                color: "#fff",
                fontWeight: "700",
              }}
            >
              {pharmacy}
            </Tag>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      {/* <ChatHeader initialColor={"#000833"} /> */}
      <Layout className="min-h-screen p-2 dashboard-layout-bg">
        <Content className="p-6 bg-[#000833] mb-8 rounded-lg ">
          {isLoading ? (
            <div className="flex justify-center items-center h-[30vh] bg-[transparent]">
              <Spin size="large" className="text-white " />
            </div>
          ) : (
            <div className="flex flex-col justify-center align-center  sm:flex-row sm:justify-between sm:items-center mb-4 mt-2 gap-4 w-full">

              <AccountUI pharmacy={accountName} />
              <div className="order-3 w-full sm:w-auto flex justify-center sm:justify-end items-center gap-3">
                <DatePicker
                  picker="month"
                  onChange={onChangeMonth}
                  defaultValue={dayjs()}
                  value={
                    selectedOption
                      ? dayjs(selectedOption.label, "MMM YYYY")
                      : dayjs()
                  }
                  allowClear={false}
                  format="MMM YYYY"
                  disabledDate={disabledMonth}
                  inputReadOnly
                  className="brand-month-picker w-full md:w-[250px]"
                  dropdownClassName="brand-month-dropdown"
                  suffixIcon={<DownOutlined style={{ color: "#fff" }} />}
                />
              </div>
            </div>
          )}
          <Row
            gutter={[24, 24]}
            className="flex flex-col sm:flex-row items-start -mb-1 sm:-mt-5"
          >
            <Col xs={24} sm={12} md={12} className="w-full sm:w-1/2">
              <div className="card">
                <span className="title ">Quarterly Brand Economics</span>
                {/* {userAuth?.user_roles_id == 5 ||
                  userAuth?.user_roles_id == 1 ? (
                  <Button
                    className="mr-2 md:ml-10 "
                    onClick={() => setIsVisible(true)}
                  >
                    Projection Calculation
                  </Button>
                ) : null} */}
              </div>
              <div className="flex flex-wrap gap-5 w-full justify-start">
                {[
                  {
                    title: "GCR (Quarter To Date)",
                    value: Number(GCRPer?.QTD_GCR_Percentage || 0).toFixed(2),
                    next: Number(GCRPer?.Next_QTD_GCR_Percentage || 0).toFixed(
                      2,
                    ),
                    last: Number(GCRPer?.Last_QTD_GCR_Percentage || 0).toFixed(
                      2,
                    ),
                    monthper: Number(GCRPer?.MTD_GCR_Percentage || 0).toFixed(
                      2,
                    ),
                    projectedGCR: Number(GCRPer?.projectedGCR || 0).toFixed(2),
                  },
                  {
                    title: "Trending COGS (Quarter To Date)",
                    value: Number(GCRPer?.QTD_COGS || 0).toFixed(2),
                    next: Number(GCRPer?.NEXT_QTD_COGS || 0).toFixed(2),
                    last: Number(GCRPer?.LAST_QTD_COGS || 0).toFixed(2),
                    cogs_impact: Number(GCRPer?.COGS_Impact).toFixed(2),
                  },
                ].map((item, idx) => (
                  <div key={idx} className="flex-1 min-w-[180px]">
                    <Card className="bg-[#DCF3FF] border-none cardAni h-full">
                      <div className="flex flex-col justify-between h-full">
                        <div className="flex items-center gap-3 smallCardTitle mb-2 justify-between">
                          <span>{item.title}</span>
                          {/* <InfoCircleOutlined /> */}
                          {/* <AntTooltip
                            placement="topRight"
                            color="transparent"
                            overlayInnerStyle={{
                              padding: 0,
                              boxShadow: "none", // ✅ shadow remove
                              background: "transparent",
                            }}
                            // title={
                            //   <div className="w-[300px] md:w-[600px]">
                            //     <GCRTooltipTable data={quarterGcrPer} />
                            //   </div>
                            // }
                          > */}
                          <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                          {/* </AntTooltip> */}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <div
                            className={`font-jetbrains smallCarddata ${
                              animateValues ? "value-update" : ""
                            }`}
                          >
                            {item.value}%
                          </div>
                          {item?.title === "Trending COGS (Quarter To Date)" &&
                            apiVersion !== "" && (
                              <span className="text-gray-700 ml-1">
                                | COGS Impact:{" "}
                                {item?.cogs_impact == "NaN" ||
                                item?.cogs_impact === undefined ||
                                isLoading ? (
                                  <Spin
                                    indicator={<LoadingOutlined spin />}
                                    size="10"
                                    className="text-[#15033f] "
                                  />
                                ) : (
                                  <span
                                    className={
                                      item?.cogs_impact < 0
                                        ? "text-red-500"
                                        : "text-green-500"
                                    }
                                  >
                                    $ {item?.cogs_impact}
                                  </span>
                                )}
                              </span>
                            )}
                        </div>

                        <span className="text-gray-700 mt-3">
                          Next Tier: {item?.next} %
                        </span>
                        <span className="text-gray-700">
                          {/* Last Period: {item.last} % */}
                          {item.title === "Trending COGS (Quarter To Date)"
                            ? "Current COGS"
                            : "Last Period"}
                          : {item.last} %
                        </span>

                        {item?.monthper !== undefined ? (
                          <span className="text-gray-700">
                            MTD : {item?.monthper} %
                          </span>
                        ) : null}

                        {item?.projectedGCR !== undefined &&
                        apiVersion !== "" ? (
                          <span className="text-gray-700">
                            Projected GCR : {item?.projectedGCR} %
                          </span>
                        ) : null}
                      </div>
                    </Card>
                  </div>
                ))}
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} className="w-full sm:w-1/2">
              <div className="card">
                <span className="title">Monthly Brand Rebates</span>
              </div>
              <div className="flex flex-wrap gap-5 w-full justify-start">
                {[
                  {
                    title: "Scrubbed GCR",
                    value: Number(GCRPer?.MON_SGCR_Percentage || 0).toFixed(2),
                    next: Number(GCRPer?.Next_MON_SGCR_Percentage || 0).toFixed(
                      2,
                    ),
                    last: Number(GCRPer?.Last_MON_SGCR_Percentage || 0).toFixed(
                      2,
                    ),
                    isTopTier: GCRPer?.isTopTier,
                  },
                  {
                    title: "GPR (Monthly)",
                    value: Number(GCRPer?.GPR_Percentage || 0).toFixed(2),
                    // value: Number(
                    //   GCRPer?.GPR_Percentage === '0.00' || GCRPer?.GPR_Percentage == null
                    //     ? 75
                    //     : GCRPer.GPR_Percentage
                    // ).toFixed(2),
                    next: Number(GCRPer?.NEXT_GPR_Percentage || 0).toFixed(2),
                    last: Number(GCRPer?.LAST_GPR_Percentage || 0).toFixed(2),
                    date: GCRPer?.isValidReportingDate
                      ? GCRPer?.GPR_Reporting_Period
                      : "",
                    isTopTier: GCRPer?.isTopTier,
                  },
                  {
                    title: "Total Brand Rebate",
                    value: Number(GCRPer?.brand_total_rebate || 0).toFixed(2),
                    next: Number(GCRPer?.nextBrandRebateTotal || 0).toFixed(2),
                    last: Number(GCRPer?.lastBrandRebateTotal || 0).toFixed(2),
                    isTopTier: GCRPer?.isTopTier,
                  },
                ].map((item, idx) => (
                  <div key={idx} className="flex-1 min-w-[150px]">
                    <Card className="bg-[#DCF3FF] border-none cardAni h-full">
                      <div className="flex flex-col justify-between h-full">
                        <div className="flex items-center gap-3 smallCardTitle mb-2 justify-between">
                          {item?.title === "GPR (Monthly)" ? (
                            <span>
                              {item?.title.replace(/\s*\(.*?\)/, "")}{" "}
                              {item?.date ? `(${item?.date})` : ""}
                            </span>
                          ) : (
                            <span>{item?.title}</span>
                          )}
                          <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                        </div>
                        {/* <div style={{ display: "flex", alignItems: "center",marginRight:-10  }}> */}

                        <div
                          className={` font-jetbrains smallCarddata ${
                            animateValues ? "value-update" : ""
                          }`}
                        >
                          {item.value}%
                        </div>

                        {/* </div> */}

                        {item.title !== "Total Brand Rebate" ? (
                          <span className="text-gray-700 mt-3">
                            {item.title === "GPR (Monthly)"
                              ? item?.isTopTier
                                ? "Top Tier"
                                : "Next"
                              : "Next"}
                            : {item?.next} %
                          </span>
                        ) : (
                          <span className="text-gray-700 invisible">
                            {item?.isTopTier ? "Top Tier" : "Next"}: 0.00 %
                          </span>
                        )}
                        <span className="text-gray-700">
                          Last Period: {item?.last} %
                        </span>
                        <span className="invisible">0.00%</span>
                      </div>
                    </Card>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Content>

        {/* <Layout className="min-h-screen bg-[#000B40]"> */}
        <Content className=" sm:p-4 sm:pt-0 pt-4">
          {!isLoading && (
            <>
              <div className="bg-[#efecfc] p-4 border border-blue-300 rounded-md shadow-md w-full mx-auto -mt-3">
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                  <h2 className="font-semibold text-lg">
                    Monthly Rebate Program
                  </h2>
                  <div className="flex items-center gap-2 text-gray-600 text-lg">
                    <InfoCircleOutlined />
                    <EllipsisOutlined />
                  </div>
                </div>

                {/* Cards Section */}
                <div className="  flex flex-wrap justify-between gap-4">
                  {/* Total Rebate */}
                  <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[32%]">
                    <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
                      Total Rebate
                    </div>
                    <div className="text-2xl font-bold mb-3 px-2 py-1 bg-[#ded7fd] font-jetbrains">
                      {/* $ {(isNaN(Number(GCRPer?.total_rebate_value)) ? 0 : Number(GCRPer.total_rebate_value)).toFixed(2)} */}
                      ${" "}
                      {(isNaN(Number(GCRPer?.total_rebate_value))
                        ? 0
                        : Number(GCRPer.total_rebate_value)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </div>
                    <div className="text-sm text-gray-700 leading-6">
                      <div className="flex">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="block font-bold">
                          OneStop Generic Rebate :{" "}
                        </p>
                        <span className="ml-2">
                          {" "}
                          ${" "}
                          {Number(
                            GCRPer?.one_stop_rebate_value || 0,
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                      <div className="flex mt-3">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="block font-bold">Brand Rebate:</p>
                        <span className="ml-2">
                          {" "}
                          ${" "}
                          {Number(
                            GCRPer?.brand_rebate_value || 0,
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* OneStop Rebate */}
                  <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[32%]">
                    <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
                      OneStop Rebate Program
                    </div>
                    <div className="text-2xl font-bold mb-3 bg-[#ded7fd] px-2 py-1 font-jetbrains">
                      ${" "}
                      {Number(
                        GCRPer?.one_stop_rebate_value || 0,
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </div>
                    <div className="text-sm text-gray-700 space-y-1">
                      <div className="flex gap-2 items-center">
                        <div className="w-1 h-6 rounded-full bg-purple-300 "></div>
                        <span className="font-bold">Rebate:</span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          SGCR:{" "}
                          {Number(GCRPer?.one_stop_sgcr_rebate || 0).toFixed(2)}
                          %
                        </span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          GPR:{" "}
                          {Number(GCRPer?.one_stop_gpr_rebate || 0).toFixed(2)}%
                        </span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          Total:{" "}
                          {Number(GCRPer?.one_stop_total_rebate || 0).toFixed(
                            2,
                          )}
                          %
                        </span>
                      </div>
                      <div className="flex mt-3">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="font-bold mt-[8px]">OneStop Rx Total:</p>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300 mt-[8px] ml-2">
                          {" "}
                          ${" "}
                          {Number(
                            GCRPer?.raw_data?.Rebatable_OneStop_Rx || 0,
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Brand Rebate */}
                  <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[32%]">
                    <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
                      Brand Rebate
                    </div>
                    <div className="text-2xl font-bold mb-3 bg-[#ded7fd] px-2 py-1 font-jetbrains">
                      ${" "}
                      {Number(GCRPer?.brand_rebate_value || 0).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                    </div>
                    <div className="text-sm text-gray-700 space-y-1">
                      <div className="flex gap-2 items-center">
                        <div className="w-1 h-6 rounded-full bg-purple-300"></div>
                        <span className="font-bold">Rebate:</span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          SGCR:{" "}
                          {Number(GCRPer?.brand_sgcr_rebate || 0).toFixed(2)}%
                        </span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          GPR:{" "}
                          {Number(GCRPer?.brand_gpr_rebate || 0).toFixed(2)}%
                        </span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          Total:{" "}
                          {Number(GCRPer?.brand_total_rebate || 0).toFixed(2)}%
                        </span>
                      </div>
                      <div className="flex mt-3">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="font-bold mt-[8px]">
                          Rebatable Brand Total:
                        </p>{" "}
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300 mt-[8px] ml-2">
                          ${" "}
                          {Number(
                            GCRPer?.raw_data?.Rebatable_Brand_Rx || 0,
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </Content>

        <Row gutter={[16, 16]} className="mb-8 mt-5">
          <Col xs={24} md={12}>
            <Card
              title={
                <div className="flex justify-between items-center">
                  <span className="cardtitle">Performance Scorecard</span>
                  <div className="flex items-center gap-4">
                    <div className="-mr-1">
                      <InfoCircleOutlined className="mr-2" />
                      <MoreOutlined />
                    </div>
                  </div>
                </div>
              }
              className="bg-white h-full CardShadow cardAni tableCard-Custom"
            >
              <div className="flex mx-2">
                <Tabs
                  activeKey={activePeriod}
                  onChange={(key) => setActivePeriod(key)}
                  className="custom-tabs w-full"
                  centered={true}
                >
                  <TabPane tab="Current Period" key="current" />
                  <TabPane tab="Previous Period" key="previous" />
                </Tabs>
              </div>

              {activePeriod == "current" ? (
                <>
                  <div className="w-full overflow-x-auto scrollbar-hide">
                    <div className="min-w-[600px]">
                      <div className="performance-table">
                        <div className=" row flex flex-wrap sm:flex-nowrap align-middle ">
                          <span className=" col metric w-full sm:w-1/3 font-bold">
                            Metric
                          </span>
                          <span className="col right w-full sm:w-1/3 text-right font-bold ">
                            {GCRPer?.raw_data?.month
                              ? `MTD (${formatMonthLabel(
                                  GCRPer.raw_data?.month,
                                )})`
                              : "MTD"}{" "}
                            $
                          </span>
                          <span className="col right w-full sm:w-1/3 text-right font-bold  ">
                            {GCRPer?.raw_quarter_data?.quarter
                              ? `QTD (${formatQuarterLabel(
                                  GCRPer?.raw_quarter_data?.quarter,
                                )})`
                              : "QTD"}{" "}
                            $
                          </span>
                        </div>

                        <div className="row total flex flex-wrap sm:flex-nowrap">
                          <div
                            className=" col metric w-full sm:w-1/3  text-2xl"
                            style={{
                              fontFamily: "Nunito Sans",
                              fontWeight: "800",
                            }}
                          >
                            Total Rx
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right  text-2xl font-bold font-jetbrains">
                            {Number(
                              GCRPer?.raw_data?.Total_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right    text-2xl font-bold font-jetbrains">
                            {Number(
                              GCRPer?.raw_quarter_data?.Total_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>

                        <div className="row section-header  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 font-bold">
                            Generic RX
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right font-bold">
                            {Number(
                              GCRPer?.raw_data?.Generic_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right font-bold">
                            {Number(
                              GCRPer?.raw_quarter_data?.Generic_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            OneStop Rx
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_data?.OnStop_Generic || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_quarter_data?.OnStop_Generic || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            RTL 2
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_data?.RTL2_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_quarter_data?.RTL2_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>

                        <div className="row section-header mt-5  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 font-bold">
                            Brand RX
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right font-bold">
                            {Number(
                              GCRPer?.raw_data?.Brand_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right font-bold">
                            {Number(
                              GCRPer?.raw_quarter_data?.Brand_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>

                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            Rebatable Brand
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_data?.Rebatable_Brand_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_quarter_data?.Rebatable_Brand_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>

                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            GLP1
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(GCRPer?.raw_data?.GLP1 || 0).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_quarter_data?.GLP1 || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            HIV
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_data?.HIV_Sum || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_quarter_data?.HIV_Sum || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            Speciality (incl. HIV)
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_data?.Specialty || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_quarter_data?.Specialty || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            Flu + COVID
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_data?.totalFluCovid || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_quarter_data?.totalFluCovid || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            Biosim
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_data?.totalBiosim || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.raw_quarter_data?.totalBiosim || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        {apiVersion !== "" && (
                          <>
                            <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                              <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                MTF Drug
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.raw_data?.totalMTF_Drug || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.raw_quarter_data?.totalMTF_Drug || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </div>

                            <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                              <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                Projected MTF Drug
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.raw_data?.projected_mtf_drug || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.raw_quarter_data
                                    ?.projected_mtf_drug || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                            <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                              <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                WAC Dollar Impact
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.raw_data?.wac_dollar_impact || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.raw_quarter_data?.wac_dollar_impact ||
                                    0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="w-full overflow-x-auto scrollbar-hide">
                    <div className="min-w-[600px]">
                      <div className="performance-table">
                        <div className=" row flex flex-wrap sm:flex-nowrap align-middle ">
                          <span className=" col metric w-full sm:w-1/3 font-bold">
                            Metric
                          </span>
                          <span className="col right w-full sm:w-1/3 text-right font-bold ">
                            {GCRPer?.lastMetrics?.month
                              ? `MTD (${formatMonthLabel(
                                  GCRPer?.lastMetrics?.month,
                                )})`
                              : "MTD"}{" "}
                            $
                          </span>
                          <span className="col right w-full sm:w-1/3 text-right font-bold  ">
                            {GCRPer?.last_quarter_Metrics?.quarter
                              ? `QTD (${formatQuarterLabel(
                                  GCRPer?.last_quarter_Metrics?.quarter,
                                )})`
                              : "QTD"}{" "}
                            $
                          </span>
                        </div>

                        <div className="row total flex flex-wrap sm:flex-nowrap">
                          <div
                            className=" col metric w-full sm:w-1/3  text-2xl"
                            style={{
                              fontFamily: "Nunito Sans",
                              fontWeight: "800",
                            }}
                          >
                            Total Rx
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right  text-2xl font-bold font-jetbrains">
                            {Number(
                              GCRPer?.lastMetrics?.Total_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right    text-2xl font-bold font-jetbrains">
                            {Number(
                              GCRPer?.last_quarter_Metrics?.Total_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>

                        <div className="row section-header  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 font-bold">
                            Generic RX
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right font-bold">
                            {Number(
                              GCRPer?.lastMetrics?.Generic_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right font-bold">
                            {Number(
                              GCRPer?.last_quarter_Metrics?.Generic_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            OneStop Rx
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.lastMetrics?.OnStop_Generic || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.last_quarter_Metrics?.OnStop_Generic || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>

                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            RTL 2
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.lastMetrics?.RTL2_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.last_quarter_Metrics?.RTL2_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>

                        <div className="row section-header mt-5  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 font-bold">
                            Brand RX
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right font-bold">
                            {Number(
                              GCRPer?.lastMetrics?.Brand_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right font-bold">
                            {Number(
                              GCRPer?.last_quarter_Metrics?.Brand_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>

                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            Rebatable Brand
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.lastMetrics?.Rebatable_Brand_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.last_quarter_Metrics
                                ?.Rebatable_Brand_Rx || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>

                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            GLP1
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.lastMetrics?.GLP1 || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.last_quarter_Metrics?.GLP1 || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            HIV
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.lastMetrics?.HIV_Sum || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.last_quarter_Metrics?.HIV_Sum || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            Speciality (incl. HIV)
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.lastMetrics?.Specialty || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.last_quarter_Metrics?.Specialty || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            Flu + COVID
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.lastMetrics?.totalFluCovid || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.last_quarter_Metrics?.totalFluCovid || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                            Biosim
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.lastMetrics?.totalBiosim || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                            {Number(
                              GCRPer?.last_quarter_Metrics?.totalBiosim || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>

                        {apiVersion !== "" && (
                          <>
                            <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                              <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                MTF Drug
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.lastMetrics?.totalMTF_Drug || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.last_quarter_Metrics?.totalMTF_Drug ||
                                    0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                            <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                              <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                Projected MTF Drug
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.lastMetrics?.projected_mtf_drug || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.last_quarter_Metrics
                                    ?.projected_mtf_drug || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                            <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                              <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                WAC Dollar Impact
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.lastMetrics?.wac_dollar_impact || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                              <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                {Number(
                                  GCRPer?.last_quarter_Metrics
                                    ?.wac_dollar_impact || 0,
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Card>
          </Col>
        </Row>
      </Layout>
      {/* <AlertMessage
        isVisible={modalVisible}
        onClose={() => setModalVisible(false)}
      /> */}
    </>
  );
};

export default ChatDashboard;
